import { compMembershipPeriod } from 'artkive/stores/ecom/constants/memberships'

import Customer from 'images/ecom/digital/CustomerAvatar.png'

export const testimonialUser = {
  address: 'Laurel, MD',
  name: 'Angelina',
  src: Customer,
}

export const digitalBullets = [
  {
    text: 'Professional photography & editing of each piece of artwork',
  },
  {
    text: `${compMembershipPeriod} months free access to the images with the option to get a membership, download or USB for long-term storage`,
  },
  { text: 'Option to order a Kids Art Book or Framed Mosaic at a later date' },
]
